import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstationcab() {



const cardData = {
  keyword: " Pune Outstation Cabs ",

"headingDescription": "Pune Outstation Cabs service offers reliable, comfortable, and affordable travel solutions for passengers planning trips from Pune to nearby cities and destinations. Whether it’s a weekend getaway, business travel, family trip, or long-distance journey, SRS Cab Service ensures a smooth and stress-free experience. With professional drivers, well-maintained vehicles, and flexible options like one-way, round trip, and customized packages, Pune Outstation Cabs provide transparent pricing with no hidden charges. Enjoy easy booking, 24/7 customer support, and a safe journey from Pune to your desired destination.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is one of Pune’s most iconic historical landmarks known for its grand architecture and Maratha heritage. Travelers using Pune Outstation Cabs often explore this fort before starting their journey."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument associated with India’s freedom movement. Visitors booking Pune Outstation Cabs can visit this serene location and explore its museum and gardens."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort offering scenic views and trekking opportunities. Travelers using Pune Outstation Cabs often visit this destination for a refreshing start before long journeys."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a renowned spiritual site in Pune. Devotees using Pune Outstation Cabs frequently visit this temple to seek blessings before beginning their trip."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Visitors using Pune Outstation Cabs explore this peaceful place located in the city center."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a diverse collection of Indian artifacts and artwork. Travelers using Pune Outstation Cabs often visit this museum to experience Pune’s cultural richness."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Visitors booking Pune Outstation Cabs often climb the hill to enjoy scenic beauty and spirituality."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful getaway known for its scenic surroundings and calm waters. Travelers using Pune Outstation Cabs often relax here before heading to their destination."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a well-maintained Japanese-style garden offering a tranquil environment. Visitors using Pune Outstation Cabs enjoy a calm walk and greenery here."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic site linked to Chhatrapati Shivaji Maharaj’s early life. Travelers using Pune Outstation Cabs visit this place to explore Pune’s rich historical heritage."
  }
],



services: [
{
name: "Pune Outstation Cab Services",
description: "Pune outstation cab services offer reliable long-distance travel for business and leisure trips. Customers can book cabs for nearby cities and tourist destinations. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel conveniently with Pune outstation cab services."
},
{
name: "Pune Outstation Taxi Booking",
description: "Pune outstation taxi booking provides easy and quick reservation options for travelers. Customers can book taxis online for long-distance trips. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your outstation taxi from Pune easily."
},
{
name: "Pune Outstation Car Rental",
description: "Pune outstation car rental offers flexible vehicle options for long-distance travel. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune for outstation trips easily."
},
{
name: "Pune Outstation Chauffeur-Driven Cabs",
description: "Pune outstation chauffeur-driven cabs provide premium travel with professional drivers. Customers can enjoy relaxed journeys without driving stress. Comfortable vehicles ensure smooth travel. Ideal for family and business trips. Flexible booking options are available. Travel comfortably with chauffeur-driven cabs from Pune."
},
{
name: "Pune Outstation One-Way Taxi",
description: "Pune outstation one-way taxi offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way taxi services from Pune."
},
{
name: "Pune Outstation Round Trip Cabs",
description: "Pune outstation round trip cabs provide convenient two-way travel options. Customers can plan return journeys with flexible schedules. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure safe journeys. Transparent pricing ensures value for money. Book round trip cabs from Pune easily."
},
{
name: "Pune Outstation Luxury Taxi",
description: "Pune outstation luxury taxi offers premium travel experience with high-end vehicles. Customers can enjoy extra comfort for long journeys. Professional chauffeurs ensure safe travel. Ideal for corporate and VIP travel needs. Flexible booking options are available. Experience luxury travel from Pune."
},
{
name: "Pune Outstation Self-Drive Car Rental",
description: "Pune outstation self-drive car rental offers flexible travel without a driver. Customers can rent cars and travel at their own pace. Well-maintained vehicles ensure safe journeys. Ideal for road trips and personal travel. Transparent pricing ensures affordability. Enjoy self-drive travel from Pune."
},
{
name: "Pune Outstation Travel Packages",
description: "Pune outstation travel packages provide complete trip solutions for tourists. Customers can explore multiple destinations with planned itineraries. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe journeys. Transparent pricing ensures value for money. Choose travel packages for hassle-free trips from Pune."
},
{
name: "Pune Outstation Private Car Hire",
description: "Pune outstation private car hire offers personalized travel experience for long journeys. Customers can enjoy private rides without sharing. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe journeys. Flexible booking options are available. Travel privately from Pune with car hire services."
},
{
name: "Pune Outstation Cabs",
description: "Pune outstation cabs provide reliable transportation for long-distance travel. Customers can choose from multiple vehicle options. Professional drivers ensure safe and smooth journeys. One-way and round trip options are available. Transparent pricing ensures affordability. Travel comfortably with Pune outstation cab services."
},
{
name: "Outstation Taxi Service Pune",
description: "Outstation taxi service Pune offers dependable travel for intercity and long-distance journeys. Customers can book taxis for business and leisure trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Choose outstation taxi services in Pune."
},
{
name: "One Way Cab Pune",
description: "One way cab Pune provides economical travel for single-direction journeys. Customers can book direct rides without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way cab services from Pune."
},
{
name: "Best Outstation Cab Service in Pune",
description: "Best outstation cab service in Pune offers top-quality travel experience for long trips. Customers can enjoy reliable service and comfortable vehicles. Professional drivers ensure safe journeys. Flexible booking options are available. Transparent pricing ensures value for money. Choose the best outstation cab services in Pune."
},
{
name: "Outstation Cab Service in Pune",
description: "Outstation cab service in Pune provides convenient travel solutions for nearby cities. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel easily with outstation cab services in Pune."
}
],

tableData: [
["Pune Outstation Cab Services","Pune Outstation Taxi Booking"],
["Pune Outstation Car Rental","Pune Outstation Chauffeur-Driven Cabs"],
["Pune Outstation One-Way Taxi","Pune Outstation Round Trip Cabs"],
["Pune Outstation Luxury Taxi","Pune Outstation Self-Drive Car Rental"],
["Pune Outstation Travel Packages","Pune Outstation Private Car Hire"],
["Pune Outstation Cabs","Outstation Taxi Service Pune"],
["One Way Cab Pune","Best Outstation Cab Service in Pune"],
["Outstation Cab Service in Pune","Pune Outstation Cab Services"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Outstation Drivers",
    WhyChoosedescription: "SRS Cab Service provides highly experienced drivers who specialize in long-distance travel from Pune to various cities, ensuring safe, smooth, and timely journeys."
  },
  {
    WhyChooseheading: "Affordable Outstation Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune outstation cab services with transparent pricing. Customers receive complete fare details including tolls and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Outstation Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for outstation cab bookings from Pune, making it convenient for business trips, family travel, and emergency journeys anytime."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort and safe intercity travel."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide flexible options including one-way drops, round-trip bookings, and customized travel plans for outstation cab services from Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and Pune Airport across all major locations including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Pune Outstation Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune outstation cab bookings due to reliable service, professional drivers, and consistent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Pune outstation cab service?", answer: "Yes, SRS Cab Service offers reliable outstation cab services from Pune to multiple cities and tourist destinations." },
  { question: "Which destinations are covered in outstation cabs from Pune?", answer: "We cover destinations like Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala, Goa, and many more." },
  { question: "Is Pune outstation cab service available 24 hours?", answer: "Yes, our outstation cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for outstation travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way outstation cab from Pune?", answer: "Yes, we provide both one-way and round-trip outstation cab services." },
  { question: "How is outstation cab fare calculated?", answer: "Outstation fare is calculated based on per km rate, minimum km per day, toll charges, and driver allowance." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and designed for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune outstation cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Patil",
    feedback:
      "Booked SRS Cab Service for outstation trip from Pune. Very comfortable journey and professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Radhika Sharma",
    feedback:
      "Best Pune outstation cab service. Affordable pricing and smooth long-distance travel experience.",
    rating: 5
  }
];

































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Outstation Cabs | SRS Cab",
  "description": "SRS Cab provides Pune outstation cab services including one-way and round-trip bookings, chauffeur-driven and self-drive cars, luxury cabs, travel packages, and private car hire. Book online for safe, comfortable, and punctual rides from Pune to outstation destinations with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune Outstation Cabs | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune outstation cabs with SRS Cab. One-way, round trips, luxury, chauffeur-driven, self-drive, private cars, and travel packages. Best outstation cab service in Pune with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneoutstationcab;